import { useContext } from 'react';
import { AuthenticationContext } from '../contexts/authentication';
import { FirebaseContext } from '../contexts/firebase';
import { AlchemyContext } from '../contexts/alchemy';
import { OpenseaContext } from '../contexts/opensea';

export const useAuthentication = () => useContext(AuthenticationContext)
export const useFirebase = () => useContext(FirebaseContext)
export const useAlchemy = () => useContext(AlchemyContext)
export const useOpensea = () => useContext(OpenseaContext)